import React, {useEffect, useRef, useState} from "react";
import SimpleMultiSelect from "../MultiSelect/SimpleMultiSelect";

function MultipleItemsSearchSelect(props) {

    const [selectedItems, setSelectedItems] = useState(props.selectedItems ? props.selectedItems : []);

    // Ref trzyma zawsze aktualny callback bez wpływu na deps useEffect
    const onChangeRef = useRef(props.onChange);
    useEffect(() => { onChangeRef.current = props.onChange; });

    // Flaga: gdy true, następny efekt onChange pominie wywołanie callbacka
    const syncingFromPropsRef = useRef(false);

    let items = [];
    if(props.items.length > 0) {
        items = props.items.map(item => ({name: item}));
    }

    useEffect(() => {
       if(props.resetSelected) {
           setSelectedItems([]);
       }}, [props.resetSelected]);

    // Sync lokalnego stanu gdy rodzic zmieni selectedItems z zewnątrz (np. inicjalizacja z URL)
    useEffect(() => {
        const incoming = JSON.stringify(props.selectedItems || []);
        const current  = JSON.stringify(selectedItems);
        if (incoming !== current) {
            syncingFromPropsRef.current = true;
            setSelectedItems(props.selectedItems || []);
        }
    }, [props.selectedItems]);

    // Odpala tylko gdy zmieni się selectedItems, nie gdy zmieni się referencja onChange
    useEffect(() => {
        if (syncingFromPropsRef.current) {
            syncingFromPropsRef.current = false;
            return;
        }
        onChangeRef.current(selectedItems);
    }, [selectedItems]);


    const deselectItemHandler = (itemName) => {
        let deselectedItemIndex = selectedItems.map((item) => item.name).indexOf(itemName);

        if (deselectedItemIndex > -1) {
            let updatedSelectedItems = [...selectedItems];
            updatedSelectedItems.splice(deselectedItemIndex, 1);
            setSelectedItems(updatedSelectedItems);
        }
    }

    const selectItemHandler = (item) => {
        let selectedItemIndex = selectedItems.findIndex(selectedItem => item.name === selectedItem.name);

        if (selectedItemIndex === -1) {
            setSelectedItems(prevSelectedItems => [...prevSelectedItems, item]);
        } else {
            deselectItemHandler(item.name);
        }
    }

    const selectAllItemsHandler = (event) => {
        if (event.target.checked) {
            setSelectedItems(items);
        } else {
            setSelectedItems([]);
        }
    }

    return (

        <SimpleMultiSelect
            itemSelected={selectItemHandler}
            itemDeselected={deselectItemHandler}
            items={items}
            selectedItems={selectedItems}
            allItemsSelected={selectAllItemsHandler}
            placeholder={props.placeholder}
            showItemImage={false}
        />
    );
}

export default MultipleItemsSearchSelect;